import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ColorFillPropertyType} from '@Components/color-fill';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

interface ScheduleHighlightedTextColorOptionProps {
  onClickColorFill(): void;
}

export function LayoutHighlightedTextColorOption({...props}: ScheduleHighlightedTextColorOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const highlightedTextColor = useGetKeyFromTableItem('highlightedTextColor');

  if (!activeItem || (activeItem && !('highlightedTextColor' in activeItem)) || !highlightedTextColor) {
    throw new Error('Item does not have highlightedTextColor property');
  }

  const onClickHandler = (): void => {
    props.onClickColorFill();
  };

  const getData = (): ColorFillStorage[] => {
    return [{id: 'schedule-highlighted-background-color', fillType: ColorFillPropertyType.SOLID, color: getColorObjectArrayFromFillColor([highlightedTextColor])}];
  };

  return <ContextualMenuColorFillOption id="highlighted-text-color-option" label={window.i18next.t('pmwjs_text_color')} data={getData()} onClick={onClickHandler} />;
}
